import { render, staticRenderFns } from "./user-group-list-header.vue?vue&type=template&id=6665e296&scoped=true"
import script from "./user-group-list-header.vue?vue&type=script&lang=js"
export * from "./user-group-list-header.vue?vue&type=script&lang=js"
import style0 from "./user-group-list-header.vue?vue&type=style&index=0&id=6665e296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6665e296",
  null
  
)

export default component.exports